import Accordion from "../components/Accordion";

import doc1 from "../docs/lotaip/2023/1_1 estructura-organica/Conjunto de datos.pdf";
import doc3 from "../docs/lotaip/2023/1_1 estructura-organica/Diccionario.pdf";
import doc2 from "../docs/lotaip/2023/1_1 estructura-organica/Metadatos.pdf";


import basedoc1 from "../docs/lotaip/2023/1_2-1_3-base-legal-regulaciones-procedimientos-internos/Conjunto de datos.pdf";
import basedoc3 from "../docs/lotaip/2023/1_2-1_3-base-legal-regulaciones-procedimientos-internos/Diccionario.pdf";
import basedoc2 from "../docs/lotaip/2023/1_2-1_3-base-legal-regulaciones-procedimientos-internos/Metadatos.pdf";


import metasdoc1 from "../docs/lotaip/2023/1-4_metas-y-objetivos_unidades/Conjunto de datos.pdf";
import metasdoc3 from "../docs/lotaip/2023/1-4_metas-y-objetivos_unidades/Diccionario.pdf";
import metasdoc2 from "../docs/lotaip/2023/1-4_metas-y-objetivos_unidades/Metadatos.pdf";


import dirdoc1 from "../docs/lotaip/2023/2_1-2_2-directorio-y-distributivo-personal-de-la-entidad/Conjunto de datos.pdf";
import dirdoc3 from "../docs/lotaip/2023/2_1-2_2-directorio-y-distributivo-personal-de-la-entidad/Diccionario.pdf";
import dirdoc2 from "../docs/lotaip/2023/2_1-2_2-directorio-y-distributivo-personal-de-la-entidad/Metadatos.pdf";



import remdoc1 from "../docs/lotaip/2023/3-remuneraciones-ingresos-adicionales/Conjunto de datos.pdf";
import remdoc3 from "../docs/lotaip/2023/3-remuneraciones-ingresos-adicionales/Diccionario.pdf";
import remdoc2 from "../docs/lotaip/2023/3-remuneraciones-ingresos-adicionales/Metadatos.pdf";



import serdoc1 from "../docs/lotaip/2023/5_22-servicios-formularios-formatos-tramites/Conjunto de datos.pdf";
import serdoc3 from "../docs/lotaip/2023/5_22-servicios-formularios-formatos-tramites/Diccionario.pdf";
import serdoc2 from "../docs/lotaip/2023/5_22-servicios-formularios-formatos-tramites/Metadatos.pdf";



import predoc1 from "../docs/lotaip/2023/6-presupuesto-de-la-institucion/Conjunto de datos.pdf";
import predoc3 from "../docs/lotaip/2023/6-presupuesto-de-la-institucion/Diccionario.pdf";
import predoc2 from "../docs/lotaip/2023/6-presupuesto-de-la-institucion/Metadatos.pdf";



import pladoc1 from "../docs/lotaip/2023/10-planes-y-programas/Conjunto de datos.pdf";
import pladoc3 from "../docs/lotaip/2023/10-planes-y-programas/Diccionario.pdf";
import pladoc2 from "../docs/lotaip/2023/10-planes-y-programas/Metadatos.pdf";



import mecdoc1 from "../docs/lotaip/2023/12-mecanismos-rendicion-cuentas/Conjunto de datos.pdf";
import mecdoc3 from "../docs/lotaip/2023/12-mecanismos-rendicion-cuentas/Diccionario.pdf";
import mecdoc2 from "../docs/lotaip/2023/12-mecanismos-rendicion-cuentas/Metadatos.pdf";

import resdoc1 from "../docs/lotaip/2023/14-responsables-del-acceso-de-informacion-publica/Conjunto de datos.pdf";
import resdoc3 from "../docs/lotaip/2023/14-responsables-del-acceso-de-informacion-publica/Diccionario.pdf";
import resdoc2 from "../docs/lotaip/2023/14-responsables-del-acceso-de-informacion-publica/Metadatos.pdf";


import texdoc1 from "../docs/lotaip/2023/15-texto-integro-de-los-contratos-colectivos-vigentes-y-reformas/Conjunto de datos.pdf";
import texdoc3 from "../docs/lotaip/2023/15-texto-integro-de-los-contratos-colectivos-vigentes-y-reformas/Diccionario.pdf";
import texdoc2 from "../docs/lotaip/2023/15-texto-integro-de-los-contratos-colectivos-vigentes-y-reformas/Metadatos.pdf";

function Lotaip2() {
  return (
    <>
      <Accordion
        title="LOTAIP 2023"
        content={
          <div className="section-acc">
            <h3> Artículo 19 </h3>

            <Accordion
              title="1.1 Estructura Orgánica	"
              content={
                <>
                  <a href={doc1}> Conjunto de datos </a>
                  <a href={doc2}> Metadatos </a>
                  <a href={doc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title="1.2-1.3 Base Legal Regulaciones Procedimientos Internos				"
              content={
                <>
                  <a href={basedoc1}> Conjunto de datos </a>
                  <a href={basedoc2}> Metadatos </a>
                  <a href={basedoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title="1.4 Metas y objetivos unidades"
              content={
                <>
                  <a href={metasdoc1}> Conjunto de datos </a>
                  <a href={metasdoc2}> Metadatos </a>
                  <a href={metasdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

       

            <Accordion
              title=" 2.1-2.2 Directorio y distributivo personal de la entidad"
              content={
                <>
                  <a href={dirdoc1}> Conjunto de datos </a>
                  <a href={dirdoc2}> Metadatos </a>
                  <a href={dirdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title=" 3. Remuneraciones ingresos adicionales"
              content={
                <>
                  <a href={remdoc1}> Conjunto de datos </a>
                  <a href={remdoc2}> Metadatos </a>
                  <a href={remdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title=" 5-22 Servicios-formularios-formatos-trámites"
              content={
                <>
                  <a href={serdoc1}> Conjunto de datos </a>
                  <a href={serdoc2}> Metadatos </a>
                  <a href={serdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title=" 6. Presupuesto de la institucion	"
              content={
                <>
                  <a href={predoc1}> Conjunto de datos </a>
                  <a href={predoc2}> Metadatos </a>
                  <a href={predoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title=" 10. Planes y programas			"
              content={
                <>
                  <a href={pladoc1}> Conjunto de datos </a>
                  <a href={pladoc2}> Metadatos </a>
                  <a href={pladoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title="12. Mecanismos rendicion cuentas"
              content={
                <>
                  <a href={mecdoc1}> Conjunto de datos </a>
                  <a href={mecdoc2}> Metadatos </a>
                  <a href={mecdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title=" 14. Responsables del acceso de informacion publica"
              content={
                <>
                  <a href={resdoc1}> Conjunto de datos </a>
                  <a href={resdoc2}> Metadatos </a>
                  <a href={resdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>

            <Accordion
              title=" 15. Texto integro de los contratos colectivos vigentes y reformas	"
              content={
                <>
                  <a href={texdoc1}> Conjunto de datos </a>
                  <a href={texdoc2}> Metadatos </a>
                  <a href={texdoc3}> Diccionario </a>
                </>
              }
            ></Accordion>
          </div>
        }
      ></Accordion>
    </>
  );
}

export default Lotaip2;
